import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isDialogOpen: false,
  isSubmitting: false,
  submitSuccess: false,
  submitError: null,
  formData: {
    issueTitle: '',
    details: '',
  },
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    openReportDialog: (state) => {
      state.isDialogOpen = true;
    },
    closeReportDialog: (state) => {
      state.isDialogOpen = false;
      state.submitSuccess = false;
      state.submitError = null;
    },
    setReportFormData: (state, action) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
    },
    submitReportRequest: (state) => {
      state.isSubmitting = true;
      state.submitError = null;
      state.submitSuccess = false;
    },
    submitReportSuccess: (state, action) => {
      state.isSubmitting = false;
      state.submitSuccess = true;
      state.submitError = null;
      state.formData = {
        issueTitle: '',
        details: '',
      };
    },
    submitReportFailure: (state, action) => {
      state.isSubmitting = false;
      state.submitSuccess = false;
      state.submitError = action.payload;
    },
    resetReportForm: (state) => {
      state.formData = {
        issueTitle: '',
        details: '',
      };
      state.submitSuccess = false;
      state.submitError = null;
      state.isSubmitting = false;
    },
  },
});

export const {
  openReportDialog,
  closeReportDialog,
  setReportFormData,
  submitReportRequest,
  submitReportSuccess,
  submitReportFailure,
  resetReportForm,
} = reportSlice.actions;

export default reportSlice.reducer;
